<template>
  <div v-if="logo === 'cc'">
    <EURorGBP v-if="currency === 'EUR' || currency === 'GBP'" />
    <CAD v-else-if="currency === 'CAD'" />
    <USD v-else />
  </div>
  <div v-if="logo === 'paypal'">
    <PayPal />
  </div>
  <div v-if="logo === 'cashapp'">
    <CashApp />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCheckoutStore } from '@/store/CheckoutStore'
import USD from './payment-logos/USD.vue'
import CAD from './payment-logos/CAD.vue'
import EURorGBP from './payment-logos/EURorGBP.vue'
import PayPal from './payment-logos/PayPal.vue'
import CashApp from './payment-logos/CashApp.vue'

const checkoutStore = useCheckoutStore()
const { currency } = storeToRefs(checkoutStore)

defineProps({
  logo: {
    type: String,
    required: true
  }
})
</script>
